import {getInputNumberValues} from '@main/helpers/get-input-number-values';

export class PhoneMask {
  constructor(el) {
    this.el = el;
    this.listenEvents();
    if (this.el.value) {
      this.onPhoneInput();
    }
  }

  listenEvents() {
    this.el.addEventListener('input', this.onPhoneInput);
    this.el.addEventListener('keydown', this.onPhoneKeyDown);
    this.el.addEventListener('paste', this.onPhonePaste);
  }

  onPhoneInput = (e) => {
    const input = this.el;
    const parent = input.parentElement;
    let inputNumbersValue = getInputNumberValues(input);
    let formattedInputValue = '';
    let selectionStart = input.selectionStart;

    parent.classList.remove('input-error');

    if (!inputNumbersValue) {
      input.value = '';
      return;
    }

    if (input.value.length !== selectionStart && e) {
      if (e.data && /\D/g.test(e.data)) {
        input.value = inputNumbersValue;
      }

      return;
    }

    if (inputNumbersValue[0] === '9') {
      inputNumbersValue = '7' + inputNumbersValue;
    }

    formattedInputValue = '+7 ';

    if (inputNumbersValue.length > 1) {
      formattedInputValue += `(${inputNumbersValue.substring(1, 4)}`;
    }

    if (inputNumbersValue.length >= 5) {
      formattedInputValue += `) ${inputNumbersValue.substring(4, 7)}`;
    }

    if (inputNumbersValue.length >= 8) {
      formattedInputValue += `-${inputNumbersValue.substring(7, 9)}`;
    }

    if (inputNumbersValue.length >= 10) {
      formattedInputValue += `-${inputNumbersValue.substring(9, 11)}`;
    }

    input.value = formattedInputValue;
  };

  onPhoneKeyDown = (e) => {
    let input = e.target;
    const parent = input.parentElement;

    parent.classList.remove('input-error');

    if (e.keyCode === 8 && getInputNumberValues(input).length === 1) {
      input.value = '';
    }
  };

  onPhonePaste = (e) => {
    const pasted = e.clipboardData || window.clipboardData;
    const input = e.target;
    const inputNumbersValue = getInputNumberValues(input);

    if (pasted) {
      const pastedText = pasted.getData('Text');

      if (/\D/g.test(pastedText)) {
        input.value = inputNumbersValue;
      }
    }
  };
}
